import { render, staticRenderFns } from "./KeyboardCustomList.vue?vue&type=template&id=679b6aae"
import script from "./KeyboardCustomList.vue?vue&type=script&lang=ts"
export * from "./KeyboardCustomList.vue?vue&type=script&lang=ts"
import style0 from "./KeyboardCustomList.vue?vue&type=style&index=0&id=679b6aae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports